export default __webpack_public_path__ + "media/images/arrow-right-dd39c75dc1e985a6c9e5373dd712dac2.svg";